/**
 * Typed env wrapper (JSDoc).
 *
 * @typedef {Object} Env
 * @property {string} API_BASE
 * @property {boolean} ENABLE_MSW
 * @property {string} MUI_LICENSE_KEY
 * @property {boolean} DEV
 * @property {boolean} PROD
 */

function readString(key, fallback = '') {
  const raw = import.meta.env[key];
  return typeof raw === 'string' ? raw : fallback;
}

function readBool(key, fallback = false) {
  const raw = import.meta.env[key];
  if (raw === 'true' || raw === true) return true;
  if (raw === 'false' || raw === false) return false;
  return fallback;
}

/** @type {Env} */
export const env = {
  API_BASE: readString('VITE_API_BASE', '/api'),
  ENABLE_MSW: readBool('VITE_ENABLE_MSW', false),
  MUI_LICENSE_KEY: readString('VITE_MUI_LICENSE_KEY', ''),
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
};
